const firebaseTopics = {
  MY_TURN: 'MY_TURN'
};

export {
  firebaseTopics
};
